module.exports = __webpack_public_path__ + "93cb10042b834b8354150f5bc19ef2dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/profeco.png
// module id = 289
// module chunks = 0